<template>
  <tr class="hover:bg-gray-50 cursor-pointer" @click="modalShow">
    <td class="px-6 py-4">
      <div class="flex items-center">
        <div class="flex-shrink-0 h-10 w-10">
          <img
              class="h-10 w-10 rounded-full"
              :src="image" alt="">
        </div>
        <div class="ml-4">
          <div :class="{'text-sm font-medium': true, 'text-gray-900': !counted, 'text-green-400': counted}">
            {{ name }}
          </div>
          <div :class="{'text-sm': true, 'text-gray-900': !counted, 'text-green-400': counted}">
            {{ id }}
          </div>
        </div>
      </div>
    </td>
    <td :class="{'px-6 py-4 whitespace-nowrap text-sm': true, 'text-gray-900': !counted, 'text-green-400': counted}">
      {{ amount }} / {{ minAmount }}
    </td>
  </tr>
</template>

<script>
import Product from './Product';
export default Product;
</script>